import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { UnitCard } from 'pages/NewOverview/components/UnitCard';
import { ThermalComfortVariant } from './types';
import { IconNames } from 'pages/NewOverview/types';
import { colors } from 'styles/colors';

interface UnitCardProps {
  variant: ThermalComfortVariant;
  value?: number;
  onClickDetails?: () => void;
  canSeeDetails?: boolean;
}

interface VariantConfig {
  cardColor: string;
  iconColor: string;
  icon: IconNames;
  /** Chave de tradução: o texto é traduzido na renderização, para acompanhar a troca de idioma. */
  descriptionKey: string;
  tooltipKey?: string;
}

const variantConfigs: Record<ThermalComfortVariant, VariantConfig> = {
  bad: {
    cardColor: colors.bg['danger-light-0'],
    descriptionKey: 'confortoRuim',
    icon: 'WavesIcon',
    iconColor: colors.state.danger.base,
  },
  comfortable: {
    cardColor: colors.bg['success-light'],
    descriptionKey: 'confortoBom',
    icon: 'Check',
    iconColor: colors.state.success.base,
  },
  regular: {
    cardColor: colors.bg['warn-light'],
    descriptionKey: 'confortoRegular',
    icon: 'ActivityIcon',
    iconColor: colors.state.warning.base,
  },
  inoperative: {
    cardColor: colors.bg['weak-100'],
    iconColor: colors.bg['soft-400'],
    descriptionKey: 'unidadesOffline',
    tooltipKey: 'unidadesOfflineTooltip',
    icon: 'SlashCircle1Icon',
  },
};

export function ThermalComfortUnitCard({
  variant,
  onClickDetails,
  value,
  canSeeDetails = true,
}: Readonly<UnitCardProps>): ReactElement {
  const { t } = useTranslation();
  const config = variantConfigs[variant];
  const size = 18;

  return (
    <UnitCard
      cardColor={config.cardColor}
      description={t(config.descriptionKey)}
      tooltip={config.tooltipKey ? t(config.tooltipKey) : undefined}
      icon={{
        color: config.iconColor,
        name: config.icon,
        size,
      }}
      value={value}
      onClickDetails={canSeeDetails ? onClickDetails : undefined}
      disabledReasonKey={!canSeeDetails ? 'semUnidadesNesseStatus' : undefined}
    />
  );
}
